import React from "react";

const inputClassName =
  "min-h-[3rem] w-full rounded-2xl border border-slate-700 bg-slate-950/80 px-4 py-3 text-sm text-slate-100 outline-none transition-all focus:border-sky-500/60 focus:ring-2 focus:ring-sky-500/20";

const EditableInput = ({
  value,
  onChange,
  multiline = false,
  rows = 4,
  ariaLabel,
  placeholder = "",
}) => {
  if (multiline) {
    return (
      <textarea
        value={value}
        onChange={onChange}
        rows={rows}
        aria-label={ariaLabel}
        placeholder={placeholder}
        className="min-h-[3rem] max-h-56 w-full overflow-y-auto rounded-2xl border border-slate-700 bg-slate-950/80 px-4 py-3 text-sm text-slate-100 outline-none transition-all focus:border-sky-500/60 focus:ring-2 focus:ring-sky-500/20"
      />
    );
  }

  return (
    <input
      type="text"
      value={value}
      onChange={onChange}
      aria-label={ariaLabel}
      placeholder={placeholder}
      className={inputClassName}
    />
  );
};

export default EditableInput;
